import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { LoginService } from '@app/core/services/login/login.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ForgotPasswordComponent } from '@app/core/components/forgot-password/forgot-password.component';
import { LocalStorageService } from '@app/core/services/localStorage/local-storage.service';
import { IUserLocalDetails } from '@app/core/services/localStorage/Ilocal-storage.interface';
import { HandleApiService } from '@app/core/services/handleApi/handle-api.service';
import { map } from 'rxjs/operators';
import { LoginAndSignUpDataComponent, PopupService } from '@app/shared/services/popup/popup.service';
import { ForceChangePasswordComponent } from '../force-change-password/force-change-password.component';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(
    private localStorage: LocalStorageService,
    private handleApi: HandleApiService,
    private formBuilder: FormBuilder,
    private router: Router,
    private loaderService: LoaderService,
    private notification: NotificationService,
    private loginService: LoginService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private dialogRef: MatDialogRef<ForgotPasswordComponent>,
    public dialogRefLogin: MatDialogRef<LoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoginAndSignUpDataComponent,
    private popupService: PopupService,
    private errorhandlerService: ErrorhandlerService
    // private dialogRefForcePassword: MatDialogRef<ForceChangePasswordComponent>
  ) {
    this.initFormLogin("", false);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  loginForm: FormGroup;
  urlToRedirect: any = null;

  initFormLogin(email, otherSite) {
    this.loginForm = this.formBuilder.group({
      Email: [email, Validators.compose([
        Validators.required,
        Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
      ]
      )],
      Password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      RememberMe: [false],
      OtherSite: [otherSite]
    });
  }

  fn_ResetOtherSites() {
    //this.loginForm.controls['OtherSite'].setValue(false);
  }

  ngOnInit() {
    $(".body").css("filter", "blur(5px)");

    //for managing the url in case we are in the detial page without login
    if (window.location.pathname.indexOf("masterproduct/detail/") !== -1)
      window.localStorage.setItem('urlToRedirect', window.location.pathname);

    this.urlToRedirect = window.localStorage.getItem('urlToRedirect');
    const StoreId = window.localStorage.getItem('storeId');
    const storeUrl = window.localStorage.getItem('storeUrl');
    const login = window.localStorage.getItem('login');
    if (login != undefined && login != "") {
      this.initFormLogin(login, true);
    }
    localStorage.clear();
    if (this.urlToRedirect) {
      window.localStorage.setItem('urlToRedirect', this.urlToRedirect);
    }
    if (StoreId) {
      window.localStorage.setItem('storeId', StoreId);
    }
    if (storeUrl) {
      window.localStorage.setItem('storeUrl', storeUrl);
    }
  }

  onSuccessLogin(res: any) {
    this.localStorage.clear();
    this.localStorage.setObject<IUserLocalDetails>({
      email: res.Data.LoginResponseModel.Email,
      inksoftUserId: res.Data.LoginResponseModel.InksoftUserId,
      role: res.Data.LoginResponseModel.Role,
      profileImage: res.Data.LoginResponseModel.ProfileImage,
      profileName: res.Data.LoginResponseModel.FullName,
      userId: res.Data.LoginResponseModel.UserId,
      userToken: res.Data.LoginResponseModel.Token,
      inksoftToken: res.Data.LoginResponseModel.tokenInksoft,
      companyId : res.Data.LoginResponseModel.CompanyId,
    });

    //   this.dialog.close
    localStorage.setItem('ForceChangePassword', res.Data.LoginResponseModel.ForceChangePassword);
    localStorage.setItem('IsReleasedLogViewed', res.Data.LoginResponseModel.IsReleasedLogViewed);
    if (res.Data.LoginResponseModel.Role === 'StoreAdmin' || res.Data.LoginResponseModel.Role === 'StoreOwner' || res.Data.LoginResponseModel.Role === 'StoreStaffMember') {
      this.dialogRef.close();
      this.notification.success(res.Message, 'Login');
      localStorage.setItem('clientToken', res.Data.LoginResponseModel.BrainTreeToken);
      localStorage.setItem('ShowWelcomeScreen', res.Data.LoginResponseModel.FirstLogin);
      if (res.Data.LoginResponseModel.SubscriptionInfo) {
        localStorage.setItem('subscriptionInfo', JSON.stringify(res.Data.LoginResponseModel.SubscriptionInfo));
      }
       if (this.urlToRedirect != "/superadmin/dashboard" && this.urlToRedirect != null) {
        if (this.urlToRedirect.indexOf("masterproduct/detail/") !== -1) {
          return this.router.navigate(['/store/' + this.urlToRedirect]);
        } else {
          window.localStorage.removeItem('urlToRedirect');
          return this.router.navigateByUrl('/store/dashboard');
        }
      } else {
        this.loaderService.hide();
        return this.router.navigateByUrl('/store/dashboard');
      }
      //this.dialogRef.close();

    }
    if (res.Data.LoginResponseModel.Role === 'SuperAdmin' || res.Data.LoginResponseModel.Role === 'CustomerService') {
      this.notification.success(res.Message, 'Login');
      this.dialogRef.close();
      if (this.urlToRedirect) {
        if (this.urlToRedirect.indexOf("masterproduct/detail/") !== -1) {
          return this.router.navigate(['/superadmin/' + this.urlToRedirect]);
        } else {
          window.localStorage.removeItem('urlToRedirect');
          return this.router.navigateByUrl(this.urlToRedirect);
        }
      } else {
        return this.router.navigate(['/superadmin/dashboard']);
      }
      // this.loaderService.hide();
    }
    if (res.Data.LoginResponseModel.Role === 'EndUser') {
      localStorage.setItem('role', 'EndUser')
      localStorage.setItem('clientToken', res.Data.LoginResponseModel.BrainTreeToken);
      window.location.reload();
    }
  }

  onSubmit(loginForm: FormGroup) {
    let storeId = null;
    if (!isNaN(parseInt(localStorage.getItem('storeId')))) {
      storeId = parseInt(localStorage.getItem('storeId'))
    }
    let loginDetails = loginForm.value;
    loginDetails = {
      ...loginDetails,
      StoreId: storeId,
      StoreName: localStorage.getItem('storeUrl'),
      SiteActive: true
    };
    this.loaderService.show();
    this.loginService.login(loginDetails)
      .pipe(map(this.handleApi.handleApi('Login', 'Invalid User')))
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.onSuccessLogin(res);
        }
      }, err => {
        this.loaderService.hide();
        this.errorhandlerService.handleError(err);
      });
  }

  openSignUp() {
    this.popupService.openSignUp(this.data.endUser);
    this.closeDialog();
  }

  openForgotPassDialog(): void {
    this.dialog.open(ForgotPasswordComponent, {
      width: window.innerWidth >= 767 ? '50%' : '80%',
    });
    this.closeDialog();
  }

  closeDialog(): void {
    $(".body").css("filter", "blur(0px)");
    this.dialogRefLogin.close();
  }


}

